import { MediaQuery, Theme } from '@pelando/components';
import styled from 'styled-components';
import EmptyState from '../../../../../components/EmptyState';

export const EmptyContainer = styled(EmptyState)`
  margin: 68px 0 46px;
  i {
    color: rgb(${Theme.colors.Brand});
  }
`;

export const TextWrapper = styled.div`
  @media ${MediaQuery.SCREEN_MD_DOWN} {
    span::before {
      content: '\A';
      white-space: pre;
    }
  }
`;
